import ChargingGroupsController from './ChargingGroupsController';

export default ChargingGroupsController;
